import { collectContactIds } from './collect-contact-ids';
import { getContactPrimaryEmail } from './get-invoice-email-recipients';
import { getParentAgreementLink } from './get-parent-agreement-link';
import type { InvoiceQuerySchema } from './schemas/invoices/invoice-query-schema';

/** Parent agreement has at least one billing contact with a primary email on file. */
export function hasParentBillingContact(invoice: InvoiceQuerySchema): boolean {
  const parentLink = getParentAgreementLink(invoice.agreement_links);
  const billingContacts = parentLink?.agreement?.billing_contact ?? [];
  if (collectContactIds(billingContacts).length === 0) {
    return false;
  }
  return billingContacts.some((contact) => getContactPrimaryEmail(contact) != null);
}
